import formaLogoNoBG from "./media/images/Forma_Logo_White.png";
import formaLogoNoBGBlackText from "./media/images/Forma_Nega_black_text_transparent.png"

export const EMAIL = "formahelsinki@hotmail.com";
export const WEBSITE = "formahelsinki.fi";
export const COMPANY_NAME = "Forma Helsinki";
export const FACEBOOK_LINK = "https://www.facebook.com/HelmiHelsinki13/";
export const INSTAGRAM_LINK = "https://www.instagram.com/formahelsinki/";
export const FORMA_LOGO_NO_BG_WHITE = formaLogoNoBG;
export const FORMA_LOGO_NO_BG_BLACK = formaLogoNoBGBlackText;
